/**
 * The one rule every public composer follows once a visitor's draft is
 * persisted (`public-composer-draft.ts`): a signed-in visitor without an
 * org continues to org creation, everyone else opens Clerk sign-up. The
 * draft is restored after auth by the launcher, so no prompt ever reaches
 * the orchestrator from a public surface.
 */

export const PUBLIC_HANDOFF_SIGNED_IN_PATH = '/create-organization'

export type PublicSignUpHandoffDeps = {
  isSignedIn: boolean
  openSignUp: () => void
  navigate: (href: string) => void
}

export function continuePublicSignUpHandoff({
  isSignedIn,
  openSignUp,
  navigate,
}: PublicSignUpHandoffDeps): void {
  if (isSignedIn) {
    navigate(PUBLIC_HANDOFF_SIGNED_IN_PATH)
    return
  }
  openSignUp()
}
